import IResultInhibitor from "../JobPage/interfaces/frontend/IResultInhibitor";

export interface FocusInhibitorDetail {
  inhibitor: IResultInhibitor,
}

export interface FocusResidueDetail {
  chain: string,
  position: number,
}

// Tell TypeScript what 'myEvent' looks like on document
declare global {
  interface DocumentEventMap {
    focusWtInhibitor: CustomEvent<FocusInhibitorDetail>;
    focusMutInhibitor: CustomEvent<FocusInhibitorDetail>;
    focusResidue: CustomEvent<FocusResidueDetail>;
  }
}

export function dispatchViewerEvent<K extends keyof DocumentEventMap>(
  type: K,
  detail: DocumentEventMap[K] extends CustomEvent<infer D> ? D : never,
  options?: Omit<CustomEventInit, "detail">
) {
  document.dispatchEvent(new CustomEvent(type, { ...options, detail }));
}
